var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 5.83688C16.9414 6.04051 16.8008 6.19115 16.6484 6.339C13.7129 9.13137 10.7803 11.9237 7.84766 14.7189C7.71289 14.8472 7.5752 14.9588 7.38184 14.9895C7.11816 15.0286 6.89258 14.9588 6.70215 14.7775C5.21387 13.3548 3.71973 11.9377 2.23438 10.5122C2.12891 10.4118 2.07617 10.2612 2 10.1356C2 10.0436 2 9.94872 2 9.85667C2.01758 9.8204 2.03809 9.78414 2.05273 9.74787C2.24316 9.30991 2.80859 9.16764 3.19531 9.46333C3.24805 9.50518 3.29492 9.54981 3.34473 9.59724C4.59863 10.7912 5.84961 11.9823 7.10352 13.1763C7.14453 13.2153 7.17969 13.2627 7.22949 13.3185C7.29102 13.2627 7.33496 13.2209 7.37891 13.1819C10.1094 10.582 12.8398 7.98207 15.5674 5.37938C15.7461 5.20922 15.9248 5.053 16.1797 5C16.2295 5 16.2764 5 16.3262 5C16.6777 5.06416 16.9033 5.25943 17 5.58581C17 5.6695 17 5.75319 17 5.83688Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.8ff7962f0b181f86bc56e4b79ab9961f.svg";
export { ForwardRef as ReactComponent };